<div
  (click)="navigateToActivityMain()"
  class="w-full bg-card rounded-3xl border border-gray-100 p-5 shadow-[0_4px_20px_rgba(0,0,0,0.02)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.05)] transition-all duration-300 flex items-center justify-between gap-4 cursor-pointer select-none"
>
  <!-- Left Side: Progress & Info -->
  <div class="flex items-center gap-4">
    <!-- Circular Progress Visual -->
    <div class="relative w-16 h-16 flex items-center justify-center flex-shrink-0">
      <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
        <!-- Gray base path -->
        <circle cx="18" cy="18" r="16" fill="none" stroke="#F1F5F9" stroke-width="3" />
        <!-- Green progress path -->
        <circle
          cx="18"
          cy="18"
          r="16"
          fill="none"
          stroke="#22c55e"
          stroke-width="3"
          stroke-linecap="round"
          [attr.stroke-dasharray]="progressPercentage + ', 100'"
          class="transition-all duration-700 ease-in-out"
        />
        <!-- Green indicator knob at the end of the progress line -->
        <circle
          [attr.cx]="knobX"
          [attr.cy]="knobY"
          r="2.2"
          fill="#22c55e"
          class="transition-all duration-700 ease-in-out"
        />
      </svg>

      <!-- Running Figure inside the circle -->
      <div class="absolute flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 256"
          fill="currentColor"
          class="w-7 h-7 text-[#22c55e]"
        >
          <path
            d="M152 88a32 32 0 1 0-32-32a32 32 0 0 0 32 32m0-48a16 16 0 1 1-16 16a16 16 0 0 1 16-16m67.31 100.68c-.61.28-7.49 3.28-19.67 3.28c-13.85 0-34.55-3.88-60.69-20a169.3 169.3 0 0 1-15.41 32.34a104.3 104.3 0 0 1 31.31 15.81C173.92 186.65 184 207.35 184 232a8 8 0 0 1-16 0c0-41.7-34.69-56.71-54.14-61.85c-.55.7-1.12 1.41-1.69 2.1c-19.64 23.8-44.25 36.18-71.63 36.18a92 92 0 0 1-9.34-.43a8 8 0 0 1 1.6-16c25.92 2.58 48.47-7.49 67-30c12.49-15.14 21-33.61 25.25-47c-38.92-22.65-63.78-3.37-64.05-3.16a8 8 0 1 1-10-12.48c1.5-1.2 37.22-29 89.51 6.57c45.47 30.91 71.93 20.31 72.18 20.19a8 8 0 1 1 6.63 14.56Z"
          />
        </svg>
      </div>
    </div>

    <!-- Text statistics -->
    <div class="flex flex-col">
      <h3 class="text-xl font-bold text-gray-900 m-0">Activity</h3>
      <p class="text-gray-500 font-semibold text-sm m-0 mt-0.5">
        Daily Goal: {{ progress }} / {{ dailyGoal }} mins
      </p>
      <div class="flex items-center gap-1.5 mt-1 text-[12px] text-gray-400 font-medium">
        <span> ~{{ caloriesBurned }} kcal</span>
        <span class="inline-block w-1.5 h-1.5 rounded-full bg-gray-200"></span>
        <span>{{ progressPercentage }}% complete</span>
      </div>
    </div>
  </div>

  <!-- Right Side: Log Button -->
  <button
    (click)="openLogModal($event)"
    [disabled]="progress >= 300"
    class="flex items-center gap-1.5 bg-[#FAFAFA] hover:bg-[#F3F4F6] disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed disabled:border-transparent text-gray-800 rounded-full px-5 py-2.5 font-bold border border-gray-100 hover:border-gray-200 transition-all duration-200 shadow-none cursor-pointer text-sm"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="2.5"
      stroke="currentColor"
      class="w-4 h-4 text-gray-600"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>
    Log
  </button>
</div>

<!-- Embedded Log Modal -->
<patient-activity-log-modal
  [(visible)]="showLogModal"
  (activityLogged)="onActivityLogged()"
></patient-activity-log-modal>

<!-- Warning Dialog for Unassigned Goal -->
<p-dialog
  [(visible)]="showNoGoalDialog"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  styleClass="no-goal-dialog"
  [style]="{ width: '90%', maxWidth: '400px', borderRadius: '24px' }"
  [header]="'Goal Not Assigned'"
>
  <div class="flex flex-col items-center text-center gap-5 pt-2 select-none">
    <div
      class="w-16 h-16 rounded-full bg-amber-50 border border-amber-100 flex items-center justify-center text-[#D97706] text-3xl"
    >
      <i class="pi pi-exclamation-triangle"></i>
    </div>

    <div class="flex flex-col gap-2">
      <h3 class="text-lg font-bold text-gray-900 m-0">Pre-Assessment Required</h3>
      <p class="text-sm text-gray-500 m-0 leading-relaxed">
        Your activity tracking goal is not assigned yet. First fill the pre-assessment, then try
        logging activities.
      </p>
    </div>

    <button
      (click)="goToPreAssessment()"
      class="w-full bg-[#22c55e] hover:bg-[#1ea34f] text-white font-bold py-3.5 px-6 rounded-full flex items-center justify-center gap-2 transition-all duration-200 border-0 cursor-pointer text-sm shadow-md"
    >
      Go to Pre-Assessment <i class="pi pi-arrow-right text-xs"></i>
    </button>
  </div>
</p-dialog>
